import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/sharp-light-svg-icons/faEnvelope';
import { faPhone } from '@fortawesome/sharp-light-svg-icons/faPhone';
import { faTimer } from '@fortawesome/sharp-light-svg-icons/faTimer';

import { FormattedMessage } from 'react-intl';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { MANAGEMENT_TYPES } from '../../../../../../global/step-up-authentication/constants';
import { messages } from '../messages';
import style from '../security.module.less';

const DisplayForType = {
  [MANAGEMENT_TYPES.EMAIL]: {
    Icon: <FontAwesomeIcon icon={faEnvelope} />,
    typeName: messages.emailName,
  },
  [MANAGEMENT_TYPES.PHONE]: {
    Icon: <FontAwesomeIcon icon={faPhone} />,
    typeName: messages.phoneName,
  },
  [MANAGEMENT_TYPES.TOTP]: {
    Icon: <FontAwesomeIcon icon={faTimer} />,
    typeName: messages.totpName,
  },
};

const TypeCell = ({ row }) => {
  const { type } = row.original;
  const { Icon, typeName = '' } = DisplayForType[type];
  return (
    <FlexRow className={style.centered} gap={Gap.Space8}>
      <FlexColumn className={style.icon}>{Icon}</FlexColumn>
      <Text textType={TextType.Paragraph} value={typeName} />
    </FlexRow>
  );
};

export const createTypeColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'type',
  Header: (
    <div>
      <FormattedMessage {...messages.columnType} />
    </div>
  ),
  Cell: TypeCell,
  width: 2,
  className: style['type-column'],
});
